import classNames from 'classnames';
import { Flex, Popover } from 'antd';
import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MoreSettings } from '@shared/assets/icons/components';
import { Text } from '@shared/ui/antd';

import styles from './settings.module.scss';

interface SettingsProps {
  onRestore: () => void;
  onRename: () => void;
  onDelete: () => void;
}

export const Settings: FC<SettingsProps> = ({ onRestore, onRename, onDelete }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'prompt.backups.settings' });
  const [open, setOpen] = useState(false);

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
  };

  const handleClick = (callback: () => void) => (event: React.MouseEvent) => {
    event.stopPropagation();
    setOpen(false);
    callback();
  };

  const items = [
    {
      key: 'restore' as const,
      title: t('restore'),
      onClick: onRestore,
    },
    {
      key: 'rename' as const,
      title: t('rename'),
      onClick: onRename,
    },
    {
      key: 'delete' as const,
      title: t('delete'),
      onClick: onDelete,
      isDanger: true,
    },
  ];

  const menu = (
    <Flex vertical>
      {items.map((item) => (
        <Flex
          key={item.key}
          align="center"
          justify="start"
          className={styles.root}
          onClick={handleClick(item.onClick)}
          gap="8px"
        >
          <Text
            variant="sm"
            fontWeight={600}
            className={classNames({ [styles.danger]: item.isDanger })}
          >
            {item.title}
          </Text>
        </Flex>
      ))}
    </Flex>
  );

  return (
    <Popover
      content={menu}
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      arrow={false}
    >
      <Flex
        justify="center"
        onClick={(event) => event.stopPropagation()}
        align="center"
        className={styles.container}
      >
        <MoreSettings />
      </Flex>
    </Popover>
  );
};
